<template>
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-4">
      <OrgProfileForm />
    </div>
    <div class="col-xl-9 col-lg-9 col-md-8">
      <OrgUsersAdmin />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import User from '@/structs/User'
import OrgProfileForm from '@/components/OrgProfileForm.vue'
import OrgUsersAdmin from '@/components/OrgUsersAdmin.vue'

export default {
  name: 'OrgAdmin',
  components: {
    OrgProfileForm,
    OrgUsersAdmin
  },
  computed: mapGetters('auth', ['currentUser']),
  data () {
    return {
      user: new User(),
      validationErrors: {
        fname: null,
        lname: null,
        email: null
      },
      formStatus: {
        success: null,
        error: null,
        statusHeading: null,
        statusBody: null
      }
    }
  },
  created () {
    this.setUser()
  },
  methods: {
    ...mapActions('user', ['update']),
    submit () {
      if (this.validateForm()) {
        this.update(this.user)
          .then(response => { this.setUser(); this.markSuccess() })
          .catch(response => { this.markError(response.message) })
      }
    },
    setUser () {
      this.user = Object.assign(new User(), this.currentUser)
    },
    showCurrentUser () {
      console.log(this.currentUser)
    },
    clearFormStatus () {
      this.formStatus.success = null
      this.formStatus.error = null
      this.statusHeading = null
      this.statusBody = null
    },
    markSuccess () {
      this.clearFormStatus()

      this.formStatus.success = true
    },
    markError (message) {
      console.log(message)
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Error'
      this.formStatus.statusBody = (message || 'Unable to create new user and/or organization.')
      this.formStatus.error = true
    },
    clearValidationErrors () {
      for (var k in this.validationErrors) {
        this.validationErrors[k] = null
      }
    },
    validateForm () {
      this.clearValidationErrors()

      if ((this.user.fname || '') === '') {
        this.validationErrors.fname = 'Empty or invalid first name'
        return false
      }

      if ((this.user.lname || '') === '') {
        this.validationErrors.lname = 'Empty or invalid last name'
        return false
      }

      if ((this.user.email || '') === '') {
        this.validationErrors.email = 'Empty or invalid email'
        return false
      }

      return true
    }
  }
}

</script>
